module.exports = __webpack_public_path__ + "img/50.757818c8.jpg";